import { useTranslate } from '../../hooks/useTranslate';
import type { SembonusUserInfo } from '../../providers/UserProvider';
import {
  Backdrop,
  Body,
  Header,
  StyledCloseButton,
  StyledDialog,
  StyledDialogPanel,
  StyledDialogTitle,
} from './AuthModal.styles';
import { Step, TitleMap } from './AuthModal.types';
import { ForgottenPasswordForm } from './components/ForgottenPasswordForm/ForgottenPasswordForm';
import { LogInForm } from './components/LogInForm/LogInForm';
import { RegisterForm } from './components/RegisterForm/RegisterForm';

interface Props {
  step: Step | undefined;
  setStep: (step: Step) => void;
  close: () => void;
  onSignedUp: ({ optedInToSembonus }: { optedInToSembonus: boolean }) => void;
  onLoggedIn: (user: SembonusUserInfo | undefined) => void;
}

export const AuthModal = ({
  step,
  setStep,
  close,
  onSignedUp,
  onLoggedIn,
}: Props) => {
  const { t } = useTranslate();

  const showForgottenPassword = () => setStep('forgotten-password');
  const showRegister = () => setStep('register');
  const showLogIn = () => setStep('log-in');

  const titleMap: TitleMap = {
    'log-in': t('ui.action.logIn.header'),
    register: t('ui.action.register.header'),
    'forgotten-password': t('ui.action.forgottenPassword.header'),
  };

  return (
    <StyledDialog open={!!step} onClose={close}>
      <Backdrop>
        <StyledDialogPanel>
          <Header>
            <StyledDialogTitle>{step ? titleMap[step] : ''}</StyledDialogTitle>

            <StyledCloseButton onClick={close} />
          </Header>

          <Body>
            {step === 'log-in' && (
              <LogInForm
                onSuccess={onLoggedIn}
                onRegister={showRegister}
                onForgottenPassword={showForgottenPassword}
              />
            )}

            {step === 'register' && (
              <RegisterForm onSuccess={onSignedUp} onLogIn={showLogIn} />
            )}

            {step === 'forgotten-password' && (
              <ForgottenPasswordForm onCancel={showLogIn} />
            )}
          </Body>
        </StyledDialogPanel>
      </Backdrop>
    </StyledDialog>
  );
};
